export default __webpack_public_path__ + "images/7381b71d61922e6f555de71489b80762-amazon-pay.svg";